import {
  Flex,
  FlexItem,
  Panel,
  SPACING_24,
  SpacingVertical,
  Text,
  TEXT_VARIANT_LIGHT,
  TEXT_VARIANT_SMALL,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import ImgClicks from 'mailup-web-components/bundle/img/icons/statistica-clic-sms.svg'
import ImgSent from 'mailup-web-components/bundle/img/icons/statistica-invii-sms.svg'
import ImgDelivered from 'mailup-web-components/bundle/img/icons/statistica-recapitati-sms.svg'
import { workflowSmsStatsState } from 'Pages/Workflow/recoil/state/stats'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import { StatBigNumber, StatsInfo } from './BoxStatistics.styles'

const intFormat = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
}

const pctFormat = {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1
}

const BoxSmsStatistics = () => {
  const intl = useIntl()

  const { show, sent, pctDelivs, pctClicks } = useRecoilValue(
    workflowSmsStatsState
  )

  /*
  const handleSmsStatsClick = (idMessage) => {
    notifyParent('redirectMainFrame', [
      `LogInvii_SMS2.aspx?source=smsstat&newsletter=${idMessage}`
    ])
  }
  */

  return show ? (
    <>
      <Panel>
        <Title variant={TITLE_VARIANT_M}>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.StatisticsSmsTitle'
          })}
        </Title>
        <SpacingVertical variant={SPACING_24} />

        <Flex justifyContent='space-between'>
          <Flex alignItems='center'>
            <img src={ImgSent} />
            <FlexItem margin='0 0 0 8px'>
              <StatBigNumber>
                {intl.formatNumber(sent, intFormat)}
              </StatBigNumber>
              <br />
              <Text variant={TEXT_VARIANT_LIGHT}>
                {intl.formatMessage({ id: 'Load.MailupCommon.Sent' })}
              </Text>
            </FlexItem>
          </Flex>
          <Flex alignItems='center'>
            <img src={ImgDelivered} />
            <FlexItem margin='0 0 0 8px'>
              <StatBigNumber>
                {intl.formatNumber(pctDelivs, pctFormat)}
              </StatBigNumber>
              <Text variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
                {' '}
                %
              </Text>
              <Text variant={TEXT_VARIANT_LIGHT}>
                {intl.formatMessage({ id: 'Load.Statistics.PercDelivered' })}
              </Text>
            </FlexItem>
          </Flex>
          <Flex alignItems='center'>
            <img src={ImgClicks} />
            <FlexItem margin='0 0 0 8px'>
              <StatBigNumber>
                {intl.formatNumber(pctClicks, pctFormat)}
              </StatBigNumber>
              <Text variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
                {' '}
                %
              </Text>
              <Text variant={TEXT_VARIANT_LIGHT}>
                {intl.formatMessage({ id: 'Load.Statistics.PercClick' })}
              </Text>
            </FlexItem>
          </Flex>
          <StatsInfo
            flex='0 0 25%'
            padding='0 16px'
            flexDirection='column'
            rowGap='4px'
          >
            <Text variant={TEXT_VARIANT_SMALL}>
              {intl.formatMessage({
                id: 'Load.AutomationWorkflow.StatisticInfoGeneric'
              })}
            </Text>
            <Text variant={TEXT_VARIANT_SMALL}>
              {intl.formatMessage({ id: 'Load.Common.HistoricizedStatistics' })}
            </Text>
          </StatsInfo>
        </Flex>
      </Panel>
    </>
  ) : null
}

export default BoxSmsStatistics
